<template lang="pug">
    .table-reservations
        transition(:name="transitionName" mode="out-in")
            router-view(:key="$route.path")
</template>

<script>
import { useSetupStore } from '@/stores';

export default {
    name: 'TableReservations',
    computed: {
        transitionName: function () {
            return useSetupStore().animation;
        }
    }
};
</script>

